import angular from 'angular';
import { NsjUsuarioInstance } from '../../core/usuario/nsj-usuario';
import { Usuario as profile } from '../../core/usuario/models/usuario-model';

export class Usuarios {

    static $inject = ['$rootScope'];

    public profile = NsjUsuarioInstance.Usuario;

    constructor($rootScope: angular.IScope & { usuario: profile }) {
        $rootScope.usuario = this.profile;
    }

    getProfile() {
        return new Promise<{data: profile}>((resolve) => {
            resolve({
                data: this.profile
            });
        });
    }
}
